module.exports = __webpack_public_path__ + "img/pick2.1fdff08a.png";